import Box from '@zenbusiness/zui/Box';
import SlideSheet from '@zenbusiness/zui/SlideSheet';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const StyledSlide = superstyled({
  name: 'StyledSlide',
  tag: SlideSheet,
  propsNeeded: ['isLoading'],
  styles: ({ theme }) => ({
    '.MuiDrawer-paper': {
      background: theme.palette.background.default,
      [theme.breakpoints.up('md')]: {
        width: '35rem',
        borderRadius: '0.75rem',
        maxHeight: 'calc( 100% - 2rem )',
        top: '1rem',
        right: '1rem'
      }
    },
    ' .ZuiDialogHeader-root': {
      padding: '1rem 1rem 0 1rem',
      ' .ZuiDialogHeader-overline': {
        fontSize: '0.75rem',
        fontWeight: 600
      },
      ' .ZuiDialogHeader-title': {
        fontSize: '1.25rem',
        fontWeight: 600
      },
      ' .ZuiDialogHeader-subtitle': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        marginTop: '0.5rem'
      }
    },
    ' .ZuiSlideSheet-content': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minHeight: 0
    },
    ' .ZuiSlideSheet-divider': {
      margin: 0,
      height: '0.0625rem'
    }
  })
});

export const SlideInFooter = superstyled({
  name: 'SlideInFooter',
  tag: Box,
  styles: {
    fontSize: '0.75rem',
    marginTop: 'auto',
    paddingTop: '1rem',
    flexShrink: 0,
    ' .MuiDivider-root': {
      marginBottom: '1.5rem',
      marginTop: 0,
      height: '0.0625rem'
    }
  }
});

export const FooterTitle = superstyled({
  name: 'FooterTitle',
  tag: Text,
  styles: {
    fontWeight: 600
  }
});

export const FooterDescription = superstyled({
  name: 'FooterDescription',
  tag: Text,
  styles: {
    lineHeight: 1.6
  }
});

export const CompletionsContainer = superstyled({
  name: 'CompletionsContainer',
  tag: 'div',
  propsNeeded: ['isLoading'],
  styles: ({ isLoading }) => ({
    padding: '1.25rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: isLoading ? 'center' : 'flex-start',
    alignItems: isLoading ? 'center' : 'stretch',
    width: '100%',
    flex: 1,
    minHeight: 0,
    overflow: 'auto'
  })
});

export const ContentWrapper = superstyled({
  name: 'ContentWrapper',
  tag: 'div',
  styles: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'stretch',
    gap: 0
  }
});
